import { LINE_NUMBER_TYPE } from "@visactor/vrender-core";

import { BaseLinePicker } from "../common/base-line-picker";

export class DefaultCanvasLinePicker extends BaseLinePicker {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "line", this.numberType = LINE_NUMBER_TYPE;
    }
}
//# sourceMappingURL=line-picker.js.map
